import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ContractorBasicInformation from './ContractorBasicInformation'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { RouteConstants } from '../../navigation/navigation-types'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import { ContractorDto, ContractorType } from '../../services/api/sharedTypes/Contractor'
import { getEmptyContractorObject } from '../../utils/contractor-utils'
import { ContractorManager } from '../../services/api/ContractorManager'
import { setSaveState } from '../../services/redux/savestate/savestate-actions'
import CustomContainer from '../../components/common/CustomContainer'
import BottomBar from '../../components/common/BottomBar'

const AddContact: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [isContractorSaving, setIsContractorSaving] = useState<boolean>(false)
    const [contractor, setContractor] = useState<ContractorDto>(getEmptyContractorObject())

    const canGoBack =
        contractor.name ||
            contractor.lastName ||
            contractor.emails.length > 0 ||
            contractor.phones.length > 0 ||
            contractor.note ||
            !contractor.canBeAssigned ||
            contractor.type !== ContractorType.Brigadier
            ? false
            : true

    useEffect(() => {
        dispatch(setSaveState(canGoBack))
    }, [canGoBack, dispatch])

    const saveContractor = async () => {
        setIsContractorSaving(true)
        const contractorManager = ContractorManager.getManager()

        try {
            const contractorRes = await contractorManager.createContractorAsync(contractor)
            if (contractorRes) {
                navigate(RouteConstants.workersAndCarriers)
                dispatch(displayMessage({ message: `Pracovník byl uložen`, type: 'success' }))
            }
        } catch (error) {
            setIsContractorSaving(false)
            return dispatch(displayMessage({ message: error, type: 'error' }))
        }
        setIsContractorSaving(false)
    }

    const saveContractorAndAddNew = async () => {
        setIsContractorSaving(true)
        const contractorManager = ContractorManager.getManager()

        try {
            const contractorRes = await contractorManager.createContractorAsync(contractor)
            if (contractorRes) {
                setContractor(getEmptyContractorObject())
                dispatch(displayMessage({ message: `Pracovník byl uložen`, type: 'success' }))
            }
        } catch (error) {
            setIsContractorSaving(false)
            return dispatch(displayMessage({ message: error, type: 'error' }))
        }
        setIsContractorSaving(false)
    }

    return (
        <CustomContainer>
            <ContractorBasicInformation contractor={contractor} setContractor={setContractor} />

            <BottomBar onSave={saveContractor} onSaveAndAdd={saveContractorAndAddNew} defaultRoute={RouteConstants.workersAndCarriers} disabled={isContractorSaving} />
        </CustomContainer>
    )
}

export default AddContact
